import type { TagItemData } from '@app/shared/ui/Tag';

interface RawTag {
  Id: number;
  Name: string | null;
  Color: string | null;
  IconId: string | null;
  Description?: string | null;
}

export const toTagItem = ({
  Id,
  Name,
  Color,
  IconId,
  Description,
}: RawTag): TagItemData => ({
  id: Id,
  label: Name ?? '',
  color: Color ?? undefined,
  iconId: IconId ?? undefined,
  description: Description ?? null,
});

export const toTagItems = (tags: RawTag[] | null | undefined): TagItemData[] =>
  (tags ?? []).map(toTagItem);
